import { z } from 'zod'
import { Timestamp } from './common.js'

// Session entity.
//
// One session per refresh cookie. Refresh token is opaque (256-bit random,
// base64url-encoded) and stored ONLY hashed (sha256) so a database leak cannot
// mint refresh JWTs. Rotation deletes the previous session document and creates
// a fresh one.

export const SessionDoc = z.object({
  id: z.string().uuid(),
  user_id: z.string().uuid(),
  refresh_token_hash: z.string(),
  created_at: Timestamp,
  expires_at: Timestamp,
  last_seen_at: Timestamp,
  user_agent: z.string().max(512).optional(),
  ip_hash: z.string().optional(),
})
export type SessionDoc = z.infer<typeof SessionDoc>
